import { useState } from 'react';
import { useEnroll2FA, useTwoFAStatus, useVerify2FA } from '../lib/queries.js';

export function TwoFAPage() {
  const { data: status } = useTwoFAStatus();
  const enroll = useEnroll2FA();
  const verify = useVerify2FA();
  const [enrolled, setEnrolled] = useState<{ qrDataUrl: string; secret: string } | null>(null);
  const [code, setCode] = useState('');
  const [verifyError, setVerifyError] = useState<string | null>(null);

  async function startEnroll() {
    const data = await enroll.mutateAsync();
    setEnrolled({ qrDataUrl: data.qrDataUrl, secret: data.secret });
  }

  async function doVerify() {
    setVerifyError(null);
    try {
      await verify.mutateAsync({ code });
      setEnrolled(null);
      setCode('');
    } catch {
      setVerifyError('código inválido');
    }
  }

  return (
    <div>
      <h1 className="text-2xl font-semibold mb-6">2FA TOTP</h1>
      <div className="rounded-lg border border-zinc-800 bg-zinc-900/40 p-6 max-w-xl">
        <div className="flex items-center gap-3 mb-4">
          <div className={`size-2 rounded-full ${status?.verified ? 'bg-emerald-500' : 'bg-zinc-500'}`} />
          <div>
            {status?.verified ? (
              <span className="text-emerald-400">Ativo e verificado</span>
            ) : status?.enrolled ? (
              <span className="text-amber-400">Cadastro pendente — verificar código</span>
            ) : (
              <span className="text-zinc-400">Não configurado</span>
            )}
          </div>
        </div>

        {!enrolled && !status?.verified && (
          <button
            onClick={startEnroll}
            disabled={enroll.isPending}
            className="rounded bg-rose-500 text-zinc-950 px-4 py-2 font-medium hover:bg-rose-400 disabled:opacity-50"
          >
            {enroll.isPending ? 'gerando…' : 'Iniciar cadastro 2FA'}
          </button>
        )}

        {enrolled && (
          <div>
            <p className="text-sm text-zinc-400 mb-3">
              Escaneie no app autenticador (Google Authenticator, Authy, 1Password):
            </p>
            <img src={enrolled.qrDataUrl} alt="QR code" className="bg-white p-2 rounded mb-3 inline-block" />
            <p className="text-xs text-zinc-500 mb-3">
              ou cole secret: <code className="text-cyan-400">{enrolled.secret}</code>
            </p>
            <div className="flex gap-2 items-center">
              <input
                value={code}
                onChange={(e) => setCode(e.target.value)}
                placeholder="código 6 dígitos"
                maxLength={6}
                pattern="\d{6}"
                className="rounded bg-zinc-950 border border-zinc-800 px-3 py-2 text-lg font-mono w-32 text-center"
              />
              <button
                onClick={doVerify}
                disabled={code.length !== 6 || verify.isPending}
                className="rounded bg-rose-500 text-zinc-950 px-4 py-2 font-medium disabled:opacity-50"
              >
                Verificar
              </button>
            </div>
            {verifyError && <div className="text-rose-400 text-sm mt-2">{verifyError}</div>}
          </div>
        )}

        {status?.verified && (
          <p className="text-xs text-zinc-500 mt-2">
            Logout e re-login exigirão o código 6 dígitos. Para desativar: chame DELETE /admin/2fa.
          </p>
        )}
      </div>
    </div>
  );
}
